import axios from 'axios'

export class AdminTriggerService {
  constructor() {
    this.endpoints = {
      list: () => '/admin/triggers',
      create: () => '/admin/triggers',
    }
  }

  static create() {
    return new AdminTriggerService()
  }

  async query(params) {
    const servicePath = this.endpoints.list()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async create(trigger) {
    const servicePath = this.endpoints.create()
    const { data } = await axios.post(servicePath, trigger)
    return data
  }
}
